import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from './ui/card';

const Kitchen = () => {
  const { t } = useTranslation();
  
  const kitchenFeatures = [
    { icon: "ChefHat", titleKey: "feature1Title", descKey: "feature1Desc" },
    { icon: "Heart", titleKey: "feature2Title", descKey: "feature2Desc" },
    { icon: "Apple", titleKey: "feature3Title", descKey: "feature3Desc" }
  ];

  return (
    <section id="kitchen" className="py-20 bg-gradient-to-br from-green-50 via-pink-50 to-purple-50">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_nido-pantano/artifacts/l0ies1t1_inbound3942261494228785523.jpg"
                alt="Cucina interna 4 KIDS"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2 space-y-6">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                {t('kitchen.title')}
              </h2>
              <p className="text-xl text-green-700 font-semibold mb-4">
                {t('kitchen.subtitle')}
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                {t('kitchen.description')}
              </p>
            </div>

            <div className="space-y-4">
              {kitchenFeatures.map((feature, index) => {
                const IconComponent = LucideIcons[feature.icon];
                return (
                  <Card key={index} className="border-0 shadow-md hover:shadow-lg transition-shadow bg-white">
                    <CardContent className="p-4 flex items-start gap-4">
                      <div className="w-12 h-12 bg-gradient-to-br from-green-100 to-pink-100 rounded-xl flex items-center justify-center flex-shrink-0">
                        {IconComponent && <IconComponent className="w-6 h-6 text-green-600" />}
                      </div>
                      <div>
                        <h3 className="font-semibold text-gray-900 mb-1">
                          {t(`kitchen.${feature.titleKey}`)}
                        </h3>
                        <p className="text-sm text-gray-600">
                          {t(`kitchen.${feature.descKey}`)}
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <p className="text-gray-700 italic">
                "{t('kitchen.quote')}"
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Kitchen;
